module.exports = __webpack_public_path__ + "img/iron-ore.3f436d78.png";